import { weatherMachineChapters } from './content';
export const weatherMachineScoring = weatherMachineChapters.filter((chapter) => /punkt|scor/i.test(chapter.title));
